import React, { useState } from "react";
import { API_BASE } from "../../Utils/constant";
import { toast } from "react-toastify";
import { AUTH_TOKEN } from "../../constants/localStorageKeys";
import { remove, retrieve } from "../../helpers/StorageHelper";

const DeleteAccount = () => {
  const [formData, setFormData] = useState({
    reason: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handlePasswordToggle = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const response = await fetch(
        `${API_BASE}/user/delete`,

        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${retrieve(AUTH_TOKEN)}`,
          },
          body: JSON.stringify({
            password: formData.password,
            reason_for_deletion: formData.reason,
          }),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        toast.error(data.message);
        throw new Error(data.message || "Something went wrong");
      }
      // setSuccess("Your account has been deleted successfully.");
      toast.success("Account Deleted Successfully!");
      setFormData({ reason: "", password: "" });
      remove("token");
      window.location.href = "/login";
    } catch (err) {
      setError(err.message);
      setTimeout(() => {
        setError(null);
      }, 2000);
    } finally {
      setLoading(false);
    }
  };

  const isFormValid = formData.reason && formData.password;

  return (
    <div style={{ height: "100%" }}>
      <div className="profile-container">
        <h1 className="setting-header text-heading-h3 mb-3 mb-md-4">
          Delete Account
        </h1>
        <form className="contact-us-form" onSubmit={handleSubmit}>
          <div className="row g-3 g-sm-4">
            <div className="col-md-6">
              <div className="textfield-1">
                <input
                  type="text"
                  className="text-body-b2"
                  placeholder=""
                  name="reason"
                  value={formData.reason}
                  onChange={handleChange}
                />
                <label className="text-body-b2">Reason for deletion</label>
              </div>
            </div>
            <div className="col-md-6">
              <div className="textfield-1 password-container">
                <input
                  type={showPassword ? "text" : "password"}
                  id="passwordInput"
                  className="text-body-b2 styled-input"
                  placeholder=""
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <label className="text-body-b2">Enter password</label>
                <button
                  type="button"
                  className="password-toggle"
                  aria-label="Toggle password visibility"
                  style={{ display: "block" }}
                  onClick={handlePasswordToggle}
                >
                  {!showPassword ? (
                    <img
                      alt="Show password"
                      src="/icons/password-eye-open.svg"
                      className="eye-open"
                    />
                  ) : (
                    <img
                      alt="Hide password"
                      src="/icons/password-eye-off-icon.svg"
                      className="eye-closed"
                    />
                  )}
                </button>
              </div>
            </div>
            <div className="col-md-12">
              <div className="delete-message-container">
                <img
                  alt="Warning"
                  className="mt-1"
                  src="/icons/delete-exclamation.svg"
                />
                <span className="text-body-b3">
                  Deleting your account is permanent and cannot be undone.
                  Please make sure that you have saved any important data before
                  proceeding. If you have any doubts, you can always cancel the
                  deletion process.
                </span>
              </div>
            </div>

            {error && <p className="text-danger mt-2">{error}</p>}
            {success && <p className="text-success mt-2">{success}</p>}
            <div className="d-flex mt-3 ">
              <button
                type="submit"
                className="btn-1 btn-1-primary"
                style={{
                  maxWidth: "240px",
                  width: "100%",
                }}
                disabled={!isFormValid || loading}
              >
                {loading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DeleteAccount;
